var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter } from 'events';
// Defined list of error Objects for JiveSession
var INVALID_CALLEE = {
    errorCode: 'INVALID_CALLEE',
    message: 'Callee parameter is invalid'
};
var UNREGISTERED_STATE = {
    errorCode: 'UNREGISTERED_STATE',
    message: 'Can\'t send request in unregistered state'
};
var DISCONNECTED_STATE = {
    errorCode: 'DISCONNECTED_STATE',
    message: 'Can\'t send request in disconnected state'
};
var SESSION_LOST = {
    errorCode: 'SESSION_LOST',
    message: 'Session was not recovered'
};
var USER_LOGOUT = {
    errorCode: 'USER_LOGOUT',
    message: 'User has logged out'
};
var UNAVAILABLE = {
    errorCode: 'UNAVAILABLE',
    message: 'Server busy, try again later'
};
var SessionEvents = /** @class */ (function (_super) {
    __extends(SessionEvents, _super);
    function SessionEvents() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * The session is registered and call related events can be sent or received
         */
        _this.REGISTERED = 'SESSION_REGISTERED';
        /*
         * The registration is in progress, but no call related events can be sent or received
         */
        _this.REGISTERING = 'SESSION_REGISTERING';
        /**
         * The session is unregistered and no call related events can be sent or received
         */
        _this.UNREGISTERED = 'SESSION_UNREGISTERED';
        /**
         * A call invite is received
         */
        _this.INVITE = 'SESSION_INVITE';
        /**
         * The session messages status was updated
         */
        _this.MESSAGES = 'SESSION_MESSAGES';
        /**
         * The session device list was updated
         */
        _this.DEVICES = 'SESSION_DEVICES';
        /**
         * An error on the session occurred
         */
        _this.ERROR = 'SESSION_ERROR';
        /**
         * The channel connection is lost and no events can be sent or received
         */
        _this.CONNECTION_LOST = 'SESSION_CONNECTION_LOST';
        /**
         * The channel is connection is restored and events can be sent or received
         */
        _this.CONNECTION_RESTORED = 'SESSION_CONNECTION_RESTORED';
        /**
         * The session is terminated, the connection is closed and no events can be sent or received
         */
        _this.TERMINATED = 'SESSION_TERMINATED';
        return _this;
    }
    Object.defineProperty(SessionEvents.prototype, "INVALID_CALLEE", {
        // Getter methods to defined errors for JiveSession
        get: function () {
            return INVALID_CALLEE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SessionEvents.prototype, "UNREGISTERED_STATE", {
        get: function () {
            return UNREGISTERED_STATE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SessionEvents.prototype, "DISCONNECTED_STATE", {
        get: function () {
            return DISCONNECTED_STATE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SessionEvents.prototype, "USER_LOGOUT", {
        get: function () {
            return USER_LOGOUT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SessionEvents.prototype, "SESSION_LOST", {
        get: function () {
            return SESSION_LOST;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SessionEvents.prototype, "UNAVAILABLE", {
        get: function () {
            return UNAVAILABLE;
        },
        enumerable: true,
        configurable: true
    });
    return SessionEvents;
}(EventEmitter));
export default SessionEvents;
//# sourceMappingURL=JiveSessionEvents.js.map